import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { EnrolmentsStore } from "@store/enrolment";
import { ConstantsStore } from "@store/constants";
import { Enrolment } from "@models/enrolment";
import { Term } from "@models/term";
import { MatrixClass } from "@models/matrix-class";
import { ClassIndexParams } from "@services/matrix-class";
import { FETCH_POTENTIAL_CLASSES, SET_ROLLOVER, SET_ROLLOVER_SUCCESS } from "@reducers/enrolments";
import { SetRolloverParams } from "@services/enrolment";
import { Actions } from "@ngrx/effects";
import { ModalService } from "@services/modal";
import { NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS } from "@constants/matrix_classes";

enum SelectedNonClassOptions { NONE }

@Component({
  selector: 'set-rollover-form',
  templateUrl: './set-rollover-form.pug',
})
export class SetRolloverFormComponent implements OnInit, OnDestroy {

  private maxPerCampus: number = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS

  private enrolmentsSubscription: Subscription
  private constantsSubscription: Subscription

  public terms: Term[]
  public term: Term
  public classes: MatrixClass[]
  public enrolment: Enrolment
  // Number is for a matrixClassId
  public selectedItem: number | SelectedNonClassOptions

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.enrolmentsSubscription = this.store.select("enrolmentsReducer").subscribe(
        (s: EnrolmentsStore) => {
          this.enrolment = s.editableEnrolment
          this.classes = s.potentialClasses
        })
    this.constantsSubscription = this.store.select("constantsReducer").subscribe(
        (s: ConstantsStore) => {
          this.terms = s.constants.terms
          this.setRelevantTerm()
          this.refreshAvailableClasses()
        })
    this.setInitialState()
  }

  setInitialState() {
    if (this.enrolment.isCancelling) {
      this.selectedItem = SelectedNonClassOptions.NONE
    }
    else if (this.enrolment.pendingEnrolment) {
      this.selectedItem = this.enrolment.pendingEnrolment.matrixClass.id
    }
  }

  setRelevantTerm() {
    let targetTerm: Term = null

    const currentTerm = this.terms.find((t: Term) => {
      return this.enrolment.matrixClass.termId == t.id
    })

    const sortedTerms = [...this.terms].sort((ta: Term, tb: Term) => {
      const a = new Date(ta.startDate)
      const b = new Date(tb.startDate)
      return a < b ? -1 : a > b ? 1 : 0
    })

    const targetTermIndex = sortedTerms.indexOf(currentTerm) + 1
    if (sortedTerms.length >= targetTermIndex - 1) {
      targetTerm = sortedTerms[targetTermIndex]
    }

    console.log(targetTerm)

    this.term = targetTerm
  }

  refreshAvailableClasses() {
    if (this.term) {
      const payload: ClassIndexParams = { termId: this.term.id }
      this.store.dispatch({ type: FETCH_POTENTIAL_CLASSES, payload })
    }
  }

  getPotentialCssClass(c: MatrixClass) {
    return `${c.code.toLowerCase()} ${this.isClassSelected(c) ? 'selected' : ''}`
  }

  clickedNone() {
    this.selectedItem = SelectedNonClassOptions.NONE
  }

  clickedClass(c: MatrixClass) {
    this.selectedItem = c.id
  }

  clickedSetRollover() {
    let targetAction
    if (this.selectedItem == SelectedNonClassOptions.NONE) {
      targetAction = "none"
    }
    else {
      // is a MatrixClass id...
      targetAction = this.selectedItem
    }

    const payload: SetRolloverParams = {
      enrolment_id: this.enrolment.id,
      target_action: targetAction
    }

    this.actions
      .ofType(SET_ROLLOVER_SUCCESS)
      .take(1)
      .subscribe(() => {
        this.modalService.closeModal()
      })

    this.store.dispatch({ type: SET_ROLLOVER, payload })
  }

  isClassSelected(c: MatrixClass): boolean {
    return this.selectedItem == c.id }
  
  isNoneSelected(): boolean {
    return this.selectedItem == SelectedNonClassOptions.NONE }

  getPendingEnrolments(mc: MatrixClass): number {
    return mc.enrolments.filter((n) => n.isPending).length }

  getActiveEnrolments(mc: MatrixClass): number {
    return mc.enrolments.filter((n) => !n.isPending).length }

  getTakenSpots(mc: MatrixClass): number {
    return this.getActiveEnrolments(mc) + this.getPendingEnrolments(mc) }

  ngOnDestroy() {
    this.enrolmentsSubscription.unsubscribe()
    this.constantsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/set-rollover-form.ts